<template>
  <v-card>
    <v-card-title>
      {{ $t('field.settings.language') }}
    </v-card-title>
    <v-card-text>
      <v-select
        v-model="language"
        :items="LanguageEnum"
        class="mt-0 pt-0"
        hide-details
        solo
      />
    </v-card-text>
  </v-card>
</template>

<script>
import { MetierLocalStorage } from 'modulelocalstorage'
import { LanguageEnum } from '@/modules/Enums'

export default {
  name: 'LanguageSettings',

  data () {
    return {
      LanguageEnum
    }
  },

  computed: {
    language: {
      get () {
        return MetierLocalStorage.getLocale()
      },
      set (val) {
        MetierLocalStorage.setLocale(val)
        this.$i18n.locale = val
        this.$emit('refresh-title')
      }
    }
  }
}
</script>
